/**
 * TEMPORARY — /admin/verification QC checklist + CRM map. DELETE WHEN DONE.
 * Self-contained: this route + src/components/admin/CrmVerification.tsx +
 * src/data/crmVerification.ts + one tile in _app.admin.index.tsx. See the
 * deletion steps documented in src/data/crmVerification.ts.
 */
import { createFileRoute } from '@tanstack/react-router';
import { CrmVerification } from '~/components/admin/CrmVerification';

export const Route = createFileRoute('/_app/admin/verification')({
  component: CrmVerification,
});
